module.exports = __webpack_public_path__ + "img/2021_1.c8b5e75a.webp";